import type { ComponentsDefinition } from '@eneco/cms';
import { cmsComponents } from '@eneco/cms-components';
import dynamic from 'next/dynamic';

/**
 * The CMS-agnostic registry for this container: the shared one plus what only this
 * container mounts.
 *
 * Applications are registered per container on the Sitecore lane too, in
 * `sitecoreComponents.ts`, and for the same reason: they cannot live in the shared
 * registry. `lib:cms-components` may not depend on `app:next` (see `depConstraints`
 * in `eslint.config.mjs`), and every container passes that one map, so a flow put
 * there would also be pulled into the containers that never render it.
 *
 * `AppPlaceholder` looks the key up by the name after `jss-app-`, so it has to match
 * the placeholder on the page, and it matches the Sitecore rendering name one to one.
 *
 * Without this file the two lanes are not comparable on this container: the flow is
 * registered on the Sitecore lane here (`sitecoreComponents.ts`), so a route renders
 * by default and renders empty under `?_cms=sanity`, which reads as a content problem
 * when it is only a missing registration.
 *
 * Only the legislation compass flow is here. The other flows in `sitecoreComponents.ts`
 * still read Sitecore directly, so mounting them on this lane would fail at the first
 * step rather than render.
 */
const components: ComponentsDefinition = {
  ...cmsComponents,
  'legislation-compass-flow': dynamic(
    () => import('@apps/flows-nl-eneco-legislationCompassFlow/LegislationCompassFlow'),
  ),
};

export default components;
